import { InputTypes, ValueTypes } from 'app/interfaces';


export default {
	key: 'nation_code',
	name: 'Nazione',
	inputType: InputTypes.DATASET_SELECT,
	valueType: ValueTypes.REFERENCE,
	datasetCode: 'nations',
	inputHint: 'Seleziona la nazione',
	remoteOptions: {
		limit: 100,
		getLabel(option): any{
			if(!option) return '';
			return option.description;
		},
		getValue(option): any{
			if(!option) return;
			return option.code;
		},
		getDisplay(option): any{
			if(!option) return '';
			return option.description;
		}
	}
};
